import {
  Component,
  output,
  input,
  OnInit,
  computed,
  signal,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IRouteDetails, IServiceInfoDetail } from 'src/app/models';
import { UserRole } from 'src/app/models/enums';
import { LiteralService, StorageService, UtilsService } from 'src/app/services';
import { TooltipPosition } from 'src/app/shared/tooltip/tooltip-position';
import { images } from 'src/images';

@Component({
  selector: 'app-service-routes-row',
  templateUrl: './service-routes-row.component.html',
  styleUrl: './service-routes-row.component.scss',
  standalone: false,
})
export class ServiceRoutesRowComponent implements OnInit {
  readonly route = input<any>();
  readonly serviceInfoRoutesSelected = input<IServiceInfoDetail>();
  readonly routeSelected = input<any>();
  readonly index = input<number>();
  readonly selectRoute = output<number>();
  readonly hideRoute = output<IRouteDetails>();
  readonly designRoute = output<number>();
  readonly isSelected = computed(() => {
    const routeSelected = this.routeSelected();
    return !!routeSelected && routeSelected.id === this.route().id;
  });
  readonly isOddRow = computed(() => this.index()! % 2 !== 0);

  public images = images;

  readonly userRole = signal<UserRole | undefined>(undefined);
  readonly isHiddenForRole = computed(
    () => !this.route().active && this.userRole() !== UserRole.ADMIN && this.userRole() !== UserRole.SUPERADMIN,
  );
  public UserRole = UserRole;
  public Number = Number;
  public TooltipPosition = TooltipPosition;

  public hiddenRoutes: any[];

  constructor(
    private storageService: StorageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public utilsService: UtilsService,
    public literalService: LiteralService,
  ) {}

  async ngOnInit() {
    this.hiddenRoutes =
      JSON.parse(await this.storageService.getHiddenRoutes()) || [];
    this.userRole.set(await this.storageService.getRole());
  }

  private setupPathSegments(): any[] {
    const serviceInfoId =
      (this.route() as any)?.serviceId ??
      this.activatedRoute.snapshot.params['id'];
    return ['/services', serviceInfoId, 'routes', this.route().id, 'setups'];
  }

  getSetupUrl(): string {
    const currentParams = this.router.parseUrl(this.router.url).queryParams;
    const queryParams = Object.entries(currentParams)
      .map(([key, value]) => `${key}=${encodeURIComponent(value as string)}`)
      .join('&');
    return `${this.setupPathSegments().join('/').replace('//', '/')}${queryParams ? `?${queryParams}` : ''}`;
  }

  goToSetup(event: any) {
    event.preventDefault();
    event.stopPropagation();
    const currentParams = this.router.parseUrl(this.router.url).queryParams;
    this.router.navigate(this.setupPathSegments(), {
      queryParams: currentParams,
    });
  }

  onDesignRoute(event: any) {
    event.stopPropagation();
    this.designRoute.emit(this.route().id);
  }

  onToggleRouteVisibility(event: any) {
    event.stopPropagation();
    if (!this.routeSelected()) this.hideRoute.emit(this.route());
  }
}
